import {Component, OnInit} from '@angular/core';
import {AbstractControl, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {QrdMulticastList} from '../../models/qrdMulticastList';
import {SymbolsService} from '../../services/symbols.service';
import * as _ from 'lodash';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {saveAs} from 'file-saver';
import {DatePipe} from '@angular/common';
import {QedMulticast} from '../../models/qedMulticast';
import {QedSymbolsInfo} from '../../models/qedSymbolsInfo';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {BaseClientComponent} from '../base-client.component';
import {forkJoin, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Component({
  selector: 'app-qrd-multicast-list',
  templateUrl: './qrd-multicast-list.component.html',
  styleUrls: ['./qrd-multicast-list.component.scss'],
  host: {class: 'sym-page sym-multicast'}
})
export class QrdMulticastListComponent extends BaseClientComponent implements OnInit {

  researchForm: UntypedFormGroup;
  qedMulticastArray: QedMulticast[];
  popList= [];
  platformOptions = ['All', 'Prod only', 'UAT only'];
  cols = [
    {field: 'pop', header: 'Pop Name', sortDisabled: true, class: '' },
    {field: 'qedSymbolName', header: 'Description', sortDisabled: true, class: ''},
    {field: 'qedChannel.name', header: 'Channel', sortDisabled: true, class: ''},
    {field: 'rawQrdIpPort', header: 'Raw QRD IP / Port', sortDisabled: true, class: ''},
    {field: 'rawQpdIpPort', header: 'Raw QPD IP / Port', sortDisabled: true, class: ''},
  ];
  qrdMulticastList: QrdMulticastList[] = [];
  filteredQrdMulticastList: QrdMulticastList[] = [];
  sfiQrdMulticastList: QrdMulticastList[] = [];
  filteredSfiQrdMulticastList: QrdMulticastList[] = [];
  alertQedSymbolHasNotChanged = false;
  qrdSymbolsInfo: QedSymbolsInfo;
  qrdSymbolsInfoData: any;
  minDateForCalendar: Date = new Date('2019-01-01');
  maxDateForCalendar: Date = null;
  startDates: string[];
  dateArray: any[];
  disabledDatesInCalendar: any[];
  updateOnDate: Date;
  userChoicesFiltersDefaultQrdMulticast = {
    pop: '',
    channel: '',
    ipAddress1: '',
    ipAddress2: '',
    ipAddress3: '',
    ipAddress4: '',
    platform: 'All'
  };

  userChoicesActiveFilters = _.clone(this.userChoicesFiltersDefaultQrdMulticast);
  public newsOnly = false;
  displayPastListsDialog = false;

  constructor(private route: ActivatedRoute,
              private utilsService: UtilsService,
              private datePipe: DatePipe,
              private _formBuilder: UntypedFormBuilder,
              private httpClient: HttpClient,
              private symbolsService: SymbolsService,
              public authenticationService: AuthenticationService, ) {
    super();
    this.maxDateForCalendar = new Date();
    this.maxDateForCalendar.setMonth(this.maxDateForCalendar.getMonth() + 1);
  }

  get popForm(): AbstractControl {
    return this.getForm('pop');
  }

  get channelForm(): AbstractControl {
    return this.getForm('channel');
  }

  get ipAddress1Form(): AbstractControl {
    return this.getForm('ipAddress1');
  }

  get ipAddress2Form(): AbstractControl {
    return this.getForm('ipAddress2');
  }

  get ipAddress3Form(): AbstractControl {
    return this.getForm('ipAddress3');
  }

  get ipAddress4Form(): AbstractControl {
    return this.getForm('ipAddress4');
  }

  get platformForm(): AbstractControl {
    return this.getForm('platform');
  }

  get pastDateRange1Form(): AbstractControl {
    return this.getForm('pastDateRange1');
  }

  get pastDateRange2Form(): AbstractControl {
    return this.getForm('pastDateRange2');
  }

  ngOnInit() {
    this.utilsService.lockUi();
    this.newsOnly = !!this.route.snapshot.data['newsOnly'];
    this.route.queryParams.subscribe(params => {
      const channelGetParameter = (params['channel']) ? params['channel'] : '';

      this.userChoicesActiveFilters = this.utilsService.loadUserPref('qrdMulticastFilter', this.userChoicesFiltersDefaultQrdMulticast);
      this.initializeResearchForm(channelGetParameter, this.userChoicesActiveFilters);
    });
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.getQrdSymbolStartDate();
    });
    this.subscriptions.push(response$);
  }

  public getDatesArray() {
    this.dateArray = [];
    const currentDate = this.minDateForCalendar;
    const stopDate = this.maxDateForCalendar;
    while (currentDate <= stopDate) {
      this.dateArray.push(this.datePipe.transform(currentDate, 'yyyy-MM-dd'));
      currentDate.setDate(currentDate.getDate() + 1);
    }
  }

  redirectionToNotFound() {
    this.utilsService.redirectToNotFound();
  }

  resetTable(): void {
    this.popForm.setValue(null);
    this.channelForm.setValue('');
    this.ipAddress1Form.setValue('');
    this.ipAddress2Form.setValue('');
    this.ipAddress3Form.setValue('');
    this.ipAddress4Form.setValue('');
    this.platformForm.setValue('All');
    this.filterMulticastList();
  }

  public createChannelListForPop(pop) {
    const list = this.qedMulticastArray
      .filter(qedMulticast => qedMulticast.popName === pop)
      .map(qedMulticast => qedMulticast.qedChannel.name)
      .sort();
    return _.uniq(list);
  }

  hasIpAddress(qrdMulticast, ipAddress1, ipAddress2, ipAddress3, ipAddress4) {
    const ipAddress = [];
    ipAddress.push(qrdMulticast.rawQrdIpPort.split('.'));
    ipAddress.push(qrdMulticast.rawQpdIpPort.split('.'));
    for (const ip of ipAddress) {
      let lastOctet;
      if (typeof ip[3] !== 'undefined') {
        lastOctet = ip[3].substr(ip.lastIndexOf('.') + 1).split('/')[0];
      }
      if (!(ipAddress1 !== '' && ip[0] !== ipAddress1
        || ipAddress2 !== '' && (!ip[1] || ip[1] !== ipAddress2)
        || ipAddress3 !== '' && (!ip[2] || ip[2] !== ipAddress3)
        || ipAddress4 !== '' && (!lastOctet || lastOctet !== ipAddress4))) {
        return true;
      }
    }
    return false;
  }

  createMulticastLists() {
    const multicastList: QrdMulticastList[] = [];
    const sfiMulticastList: QrdMulticastList[] = [];
    for (const pop of this.popList) {
      for (const channel of this.createChannelListForPop(pop)) {
        const multicastNonProt: QedMulticast[] = this.qedMulticastArray.filter(qedMulticast =>
          qedMulticast.popName === pop
          && qedMulticast.qedChannel.name === channel
          && qedMulticast.isProtected === false);
        const multicastProt: QedMulticast[] = this.qedMulticastArray.filter(qedMulticast =>
          qedMulticast.popName === pop
          && qedMulticast.qedChannel.name === channel
          && qedMulticast.isProtected === true);
        if (multicastNonProt && multicastNonProt.length > 0 || multicastProt && multicastProt.length > 0) {
          const sfiPermissionningId = multicastNonProt?.[0]?.sfiPermissionningId || multicastProt?.[0]?.sfiPermissionningId;
          const isAvailableInQpd = multicastNonProt?.[0]?.isAvailableInQpd || multicastProt?.[0]?.isAvailableInQpd;
          const multicast: QrdMulticastList = {
            pop: pop,
            qedSymbolName: multicastNonProt?.[0]?.qedSymbolName || multicastProt?.[0]?.qedSymbolName,
            qedChannel: multicastNonProt && multicastNonProt.length > 0 ? multicastNonProt[0].qedChannel : multicastProt[0].qedChannel,
            platform: multicastNonProt && multicastNonProt.length > 0 ? multicastNonProt[0].platform : multicastProt[0].platform,
            rawQrdIpPort: multicastNonProt.length > 0 ? this.getRawQrdIp(multicastNonProt) + '/' + this.getRawQrdPort(multicastNonProt) : '',
            rawQpdIpPort: multicastProt.length > 0 ? this.getRawQpdIp(multicastProt) + '/' + this.getRawQpdPort(multicastProt) : '',
            sfiPermissionningId: sfiPermissionningId,
          };
          if (sfiPermissionningId != null) {
            sfiMulticastList.push(multicast);
          }
          if (sfiPermissionningId == null || isAvailableInQpd) {
            multicastList.push(multicast);
          }
        }
      }
    }
    return {
      multicastList: multicastList,
      sfiMulticastList: sfiMulticastList
    };
  }

  getRawQrdIp(multicastNonProt) {
    return (multicastNonProt.length > 0) ? multicastNonProt[0].mcastIp : '';
  }

  getRawQrdPort(multicastNonProt) {
    return (multicastNonProt.length > 0) ? multicastNonProt[0].port : '';
  }

  getRawQpdIp(multicastProt) {
    return (multicastProt.length > 0) ? multicastProt[0].mcastIp : '';
  }

  getRawQpdPort(multicastProt) {
    return (multicastProt.length > 0) ? multicastProt[0].port : '';
  }

  filterMulticastList() {
    this.utilsService.saveUserData('qrdMulticastFilter',
      {
        'pop': this.popForm.value,
        'channel': this.channelForm.value,
        'ipAddress1': this.ipAddress1Form.value,
        'ipAddress2': this.ipAddress2Form.value,
        'ipAddress3': this.ipAddress3Form.value,
        'ipAddress4': this.ipAddress4Form.value,
        'platform': this.platformForm.value
      });
    if (this.platformForm.value === 'All'
      && this.popForm.value === ''
      && this.channelForm.value === ''
      && this.ipAddress1Form.value === ''
      && this.ipAddress2Form.value === ''
      && this.ipAddress3Form.value === ''
      && this.ipAddress4Form.value === '') {
      this.filteredQrdMulticastList = this.qrdMulticastList;
    }
    this.filteredQrdMulticastList = this.filters(this.qrdMulticastList);
    this.filteredSfiQrdMulticastList = this.filters(this.sfiQrdMulticastList)
      .filter(m => m.sfiPermissionningId);
  }

  channelsWithSamePop(pop) {
    return this.filteredQrdMulticastList.filter(qrdMulticast => qrdMulticast.pop === pop);
  }

  sfiRowsWithSamePop(pop) {
    return this.filteredSfiQrdMulticastList.filter(m => m.pop === pop);
  }

  verifyDateSelected(rangeDate1 = false, rangeDate2 = false) {
    if (!this.pastDateRange1Form.value || !this.pastDateRange2Form.value) {
      return;
    }
    this.symbolsService.verifyDateSelected(rangeDate1, rangeDate2, this.pastDateRange1Form, this.pastDateRange2Form);
  }

  downloadQrdMulticastsWithThisDateRange() {
    this.symbolsService.addCsvFilesToZipFileWhenDateRangeSelected(
      this.pastDateRange1Form, this.pastDateRange2Form, this.filteredQrdMulticastList, 'QRD', true);
  }

  rangeDateNotSelected() {
    return !this.pastDateRange1Form.value
      || !this.pastDateRange2Form.value;
  }

  downloadRangeQrdMulticastList() {
    this.httpClient.get(environment.baseUrlWs + '/api/multicast-list-by-dates?service=qrd&start_date='
      + this.datePipe.transform(this.pastDateRange1Form.value, 'yyyy-MM-dd')
      + '&end_date=' + this.datePipe.transform(this.pastDateRange2Form.value, 'yyyy-MM-dd'))
      .subscribe({
        next: (response) => {
          const blob = this.symbolsService.b64toBlob(response['file_content'], response['mime_type'], null);
          saveAs(blob, response['file_name']);
        }, error: (error: HttpResponse<any>) => {
          this.utilsService.handleErrorWebservice$(error);
        }
      });
  }

  downloadCurrentQrdMulticastList() {
    this.httpClient.get(environment.baseUrlWs + '/api/multicast-list?service=qrd&ui=1')
      .subscribe({
        next: (response) => {
          const blob = this.symbolsService.b64toBlob(response['file_content'], response['mime_type'], null);
          saveAs(blob, response['file_name']);
        }, error: (error: HttpResponse<any>) => {
          this.utilsService.handleErrorWebservice$(error);
        }
      });
  }

  resetRangeDates() {
    this.pastDateRange1Form.setValue('');
    this.pastDateRange2Form.setValue('');
  }

  private getQrdSymbolStartDate() {
    this.symbolsService.getSymbolStartDates('qrd').subscribe({
      next: qrdSymbolsStartDates => {
        this.startDates = qrdSymbolsStartDates;
        this.getDatesArray();
        const disabledDatesStrings = this.dateArray.filter(item => this.startDates.indexOf(item) < 0);
        this.disabledDatesInCalendar = disabledDatesStrings.map(date => new Date(date));
        this.getQrdSymbolsInfo();
      }, error: () => {
        this.utilsService.unlockUi();
        this.utilsService.displayMessage('The multicast list could not be loaded', 'Please try again later.', 'error');
      }
    });
  }

  private getQrdSymbolsInfo() {
    this.symbolsService.getQrdSymbolInfo().subscribe({
        next: qrdSymbolsInfo => {
          if (qrdSymbolsInfo.length === 1) {
            this.qrdSymbolsInfo = qrdSymbolsInfo[0];
            this.updateOnDate = qrdSymbolsInfo[0].updatedAt;
            this.qrdSymbolsInfoData = JSON.parse(this.qrdSymbolsInfo.data);
            this.getQrdMulticastList();
          } else {
            this.alertQedSymbolHasNotChanged = true;
            this.utilsService.unlockUi();
          }
        }, error: () => {
          this.alertQedSymbolHasNotChanged = true;
          this.utilsService.unlockUi();
        }
      }
    );
  }

  private getQrdMulticastList() {
    if (this.startDates && this.startDates[0]) {
      forkJoin({
        list: this.symbolsService.getMulticastList('qrd', this.startDates[0], this.newsOnly),
        details: this.symbolsService.getMulticastDetailsList('qrd', this.startDates[0]).pipe(catchError(() => of({})))
      }).subscribe({
          next: ({list, details}) => {
            list.forEach(multicast => {
              const resMulticast = details[multicast.id];
              if (resMulticast) {
                multicast.qedSymbolName = resMulticast.qedSymbolName;
                multicast.product = resMulticast.product;
              }
            });
            this.qedMulticastArray = list;
            this.createPopNames();
            const { multicastList, sfiMulticastList } = this.createMulticastLists();
            this.qrdMulticastList = multicastList;
            this.sfiQrdMulticastList = sfiMulticastList;
            this.filterMulticastList();
            this.utilsService.unlockUi();
          },
          error: () => {
            this.redirectionToNotFound();
          }
        }
      );
    } else {
      this.redirectionToNotFound();
    }
  }

  private initializeResearchForm(channelName = '', userChoicesActiveFilters) {
    this.researchForm = this._formBuilder.group({
      pop: userChoicesActiveFilters.pop,
      channel: (channelName) ? channelName : userChoicesActiveFilters.channel,
      ipAddress1: userChoicesActiveFilters.ipAddress1,
      ipAddress2: userChoicesActiveFilters.ipAddress2,
      ipAddress3: userChoicesActiveFilters.ipAddress3,
      ipAddress4: userChoicesActiveFilters.ipAddress4,
      platform: userChoicesActiveFilters.platform,
      pastDateRange1: [''],
      pastDateRange2: ['']
    });
    this.subscriptions.push(
      this.pastDateRange1Form.valueChanges.subscribe(() => this.verifyDateSelected(true)),
      this.pastDateRange2Form.valueChanges.subscribe(() => this.verifyDateSelected(false, true))
    );
  }

  private getForm(formName: string): AbstractControl {
    return this.researchForm.get(formName);
  }

  private createPopNames() {
    const list = this.qedMulticastArray
      .map(qedMulticast => qedMulticast.popName)
      .sort();
    const listPops = _.uniq(list);
    this.popList = listPops;
    if (!this.popForm.value) {
      this.popForm.setValue(null);
    }
  }

  private filters(filteredMulticastList: QrdMulticastList[]) {
    filteredMulticastList = this.filterByPLatform(filteredMulticastList);
    filteredMulticastList = this.filterByPop(filteredMulticastList);
    filteredMulticastList = this.filterByChannel(filteredMulticastList);
    filteredMulticastList = this.filterByAddressIp(filteredMulticastList);
    return filteredMulticastList;
  }

  private filterByAddressIp(filteredMulticastList: QrdMulticastList[]) {
    if (this.ipAddress1Form.value !== ''
      || this.ipAddress2Form.value !== ''
      || this.ipAddress3Form.value !== ''
      || this.ipAddress4Form.value !== '') {
      filteredMulticastList = filteredMulticastList.filter(qrdMulticast =>
        this.hasIpAddress(qrdMulticast,
          this.ipAddress1Form.value,
          this.ipAddress2Form.value,
          this.ipAddress3Form.value,
          this.ipAddress4Form.value));
    }
    return filteredMulticastList;
  }
  private filterByChannel(filteredMulticastList: QrdMulticastList[]): QrdMulticastList[] {
    if (this.channelForm.value !== '') {
      const filterValue = this.channelForm.value.toLowerCase();
      filteredMulticastList = filteredMulticastList.filter(qrdMulticast => qrdMulticast.qedChannel.name.toLowerCase().includes(filterValue));
    }
    return filteredMulticastList;
  }

  private filterByPop(filteredMulticastList: QrdMulticastList[]) {
    if (this.popForm.value) {
      filteredMulticastList = filteredMulticastList.filter(qrdMulticast =>
        qrdMulticast.pop.toLowerCase() === this.popForm.value.toLowerCase()
      );
    }
    return filteredMulticastList;
  }

  private filterByPLatform(filteredMulticastList: QrdMulticastList[]) {
    if (this.platformForm.value !== 'All') {
      if (this.platformForm.value !== 'Prod only') {
        filteredMulticastList = filteredMulticastList.filter(qrdMulticast => qrdMulticast.platform === 'qrd_uat');
      } else {
        filteredMulticastList = filteredMulticastList.filter(qrdMulticast => qrdMulticast.platform === 'qrd_prod');
      }
    }
    return filteredMulticastList;
  }

  onPasteIp(event: ClipboardEvent) {
    let ipAddress = event.clipboardData?.getData('text') || '';
    ipAddress = ipAddress.trim();
    const parts = ipAddress.split('.');
    if (parts.length === 4) {
      this.researchForm.patchValue({
        ipAddress1: parts[0], ipAddress2: parts[1],
        ipAddress3: parts[2], ipAddress4: parts[3],
      });
      event.preventDefault();
    }
    if (parts.length === 3) {
      this.researchForm.patchValue({
        ipAddress1: parts[0], ipAddress2: parts[1],
        ipAddress3: parts[2],
      });
      event.preventDefault();
    }
    if (parts.length === 2) {

      this.researchForm.patchValue({
        ipAddress1: parts[0], ipAddress2: parts[1]
      });
      event.preventDefault();
    }
    this.filterMulticastList();
  }


}
